import { RowFillerTransformRule, Qualifier, Qualifier2, GroupFillType } from 'src/app/domainObjects/transformers/rowFillerTransform';
import { TransformRuleViewModel } from 'src/app/viewModels/transformRuleViewModel';

export class RowFillerRuleViewModel extends TransformRuleViewModel {
  fillType: GroupFillType;
  qualifier1: Qualifier;
  qualifier1Value: string;
  qualifier2: Qualifier2;
  qualifier2Value: number;
  currentRowField: string;
  currentRowQualifier: Qualifier;
  currentRowValue: string;
  timeout: number;
  run: boolean;

  groupHits?: number;
  rowHits?: number;
  sampleGroupHits?: number;
  sampleRowHits?: number;

  constructor(rule: RowFillerTransformRule) {
    super(rule.ruleId, rule.index, rule.run, rule.ruleName);

    this.name = rule.name;
    this.run = rule.run;
    this.fillType = rule.fillType;
    this.qualifier1 = rule.qualifier1;
    this.qualifier1Value = rule.qualifier1Value;
    this.qualifier2 = rule.qualifier2;
    this.qualifier2Value = rule.qualifier2Value;
    this.currentRowField = rule.currentRowField;
    this.currentRowQualifier = rule.currentRowQualifier;
    this.currentRowValue = rule.currentRowValue;
    this.timeout = rule.timeout;
    this.run = rule.run;
  }

  toRowFillerRule(): RowFillerTransformRule {
    const rule = new RowFillerTransformRule();

    rule.index = this.index - 1;
    rule.ruleName = this.ruleName;
    rule.fillType = this.fillType;
    rule.qualifier1 = this.qualifier1;
    rule.qualifier1Value = this.qualifier1Value;
    rule.qualifier2 = this.qualifier2;
    rule.qualifier2Value = this.qualifier2Value;
    rule.currentRowField = this.currentRowField;
    rule.currentRowQualifier = this.currentRowQualifier;
    rule.currentRowValue = this.currentRowValue;
    rule.timeout = this.timeout;
    rule.run = this.run;

    return rule;
  }
}